import React from 'react';
import { styles } from './WalletButton.css';
import { getDetectedPlatform } from '../getDetectedPlatform';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { AddToWalletUrls } from '../../CouponModal/CouponModal';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner/Spinner';
import { ga4WalletClickTracking } from './utils';
import { useNavigate } from '../../PlatformFunctionality';

const APPLE_WALLET_URL =
  'https://cdn.shopify.com/s/files/1/0030/3235/0789/files/US-UK_Add_to_Apple_Wallet_RGB_101421_3.png';
const GOOGLE_WALLET_URL =
  'https://cdn.shopify.com/s/files/1/0030/3235/0789/files/enSG_add_to_google_wallet_add-wallet-badge_1.png';

type WalletButtonProps = {
  className?: string;
  setIsQrModalOpen: (isOpen: boolean) => void;
  setClickedWallet: (wallet: 'apple' | 'google' | null) => void;
  addToWalletUrls?: AddToWalletUrls;
  cardType: 'coupon' | 'member card';
  location?: 'modal' | 'header';
};

export const WalletButton: React.FC<WalletButtonProps> = ({
  className,
  setIsQrModalOpen,
  setClickedWallet,
  addToWalletUrls,
  cardType,
  location = 'header',
}) => {
  const isDesktop = useBreakpoint('md', 'up');
  const platform = getDetectedPlatform();
  const navigate = useNavigate();

  if (!addToWalletUrls?.googleLink && !addToWalletUrls?.appleLink) {
    return <Spinner className={styles.spinner} />;
  }

  const onAppleClick = () => {
    ga4WalletClickTracking({
      walletType: 'Apple',
      cardType,
      location,
    });
    if (isDesktop) {
      setIsQrModalOpen(true);
      setClickedWallet('apple');
    } else if (addToWalletUrls.appleLink) {
      navigate(addToWalletUrls.appleLink);
    }
  };
  const onGoogleClick = () => {
    ga4WalletClickTracking({
      walletType: 'Google',
      cardType,
      location,
    });

    if (isDesktop) {
      setIsQrModalOpen(true);
      setClickedWallet('google');
    } else if (addToWalletUrls.googleLink) {
      navigate(addToWalletUrls.googleLink);
    }
  };

  if (platform === 'android') {
    return (
      <button onClick={onGoogleClick} className={`${styles.addToWalletButton} ${className}`}>
        <img src={GOOGLE_WALLET_URL} width={160} alt="Google Wallet" />
      </button>
    );
  }

  if (platform === 'ios') {
    return (
      <button onClick={onAppleClick} className={`${styles.addToWalletButton} ${className}`}>
        <img src={APPLE_WALLET_URL} width={155} alt="Apple Wallet" />
      </button>
    );
  }

  // desktop fallback: show both
  return (
    <>
      <button onClick={onGoogleClick} className={`${styles.addToWalletButton} ${className}`}>
        <img src={GOOGLE_WALLET_URL} width={160} alt="Google Wallet" />
      </button>
      <button onClick={onAppleClick} className={`${styles.addToWalletButton} ${className}`}>
        <img src={APPLE_WALLET_URL} width={155} alt="Apple Wallet" />
      </button>
    </>
  );
};
